<template>
  <div class="Pie6Charts">
    <div class="echarts" :id="Configuration.id"></div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { request } from '../../../../common/request';
export default {
  name: 'Pie6Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {},
  methods: {
    getChartWidth() {
      return this.Configuration.style.width;
    },
    getChartHeight() {
      return this.Configuration.style.height;
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      console.log(grid);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(source);
      console.log(seriesList);

      let xData = [];
      let yData = [];
      let xyData = [];
      let unit = '';

      function DealData() {
        seriesList.forEach(s => {
          source.forEach((item, index) => {
            if (s === item.s) {
              unit = item.s;
              if (index >= 4) return;
              xData.push(item.x);
              yData.push(item.y);

              xyData.push({
                name: item.x,
                value: parseInt(item.y),
              });
            }
          });
        });
      }
      DealData();

      let imgSrc =
        'data:image/png;base64,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';

      var data = [...xyData];
      var titleArr = [],
        seriesArr = [];
      var sCenter,
        TitleXy = {};
      var colors = [
        [[chartColor[0], this.$tinycolor(chartColor[0]).setAlpha(0.2).toRgbString()]],
        [[chartColor[1], this.$tinycolor(chartColor[1]).setAlpha(0.2).toRgbString()]],
        [[chartColor[2], this.$tinycolor(chartColor[2]).setAlpha(0.2).toRgbString()]],
        [[chartColor[3], this.$tinycolor(chartColor[3]).setAlpha(0.2).toRgbString()]],
      ];

      data.forEach((item, index) => {
        if (index < 2) {
          sCenter = [index * 35 + 30 + '%', '26%'];

          TitleXy = {
            left: index * 35 + 30 + '%',
            top: '27%',
          };
        } else {
          sCenter = [(index - 2) * 35 + 30 + '%', '75%'];
          TitleXy = {
            left: (index - 2) * 35 + 30 + '%',
            top: '72%',
          };
        }

        titleArr.push({
          text: item.name,
          left: TitleXy.left,
          top: TitleXy.top,
          textAlign: 'center',
          textStyle: {
            fontWeight: 'bold',
            fontSize: this.$w_Ratio(18, this.$store),
            color: colors[index][0][0],
            textAlign: 'center',
          },
        });
        seriesArr.push({
          type: 'pie',
          radius: [0, this.getChartWidth() / 14],
          center: sCenter,
          data: [
            {
              label: {
                show: false,
              },
              value: 100,
              hoverAnimation: false,
              itemStyle: {
                color: colors[index][0][1],
                // shadowBlur: 5,
                shadowColor: 'rgba(0, 0, 0, 0)',
                shadowOffsetX: '3',
                shadowOffsetY: '3',
              },
            },
          ],
        });
        seriesArr.push({
          name: item.name,
          type: 'pie',
          clockWise: false,
          radius: [this.getChartWidth() / 14 + 10, this.getChartWidth() / 14 + 20],
          itemStyle: {
            normal: {
              color: colors[index][0][0],
              shadowColor: colors[index][0],
              shadowBlur: 0,
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
            },
          },
          hoverAnimation: false,
          center: sCenter,
          data: [
            {
              value: item.value,
              label: {
                normal: {
                  formatter: function (params) {
                    return '{a|}\n' + params.seriesName + '\n' + params.value + unit;
                  },
                  lineHeight: this.$w_Ratio(20, this.$store),
                  position: 'center',
                  show: true,
                  textStyle: {
                    fontSize: this.$w_Ratio(16, this.$store),
                    fontWeight: 'bold',
                    color: colors[index][0][0],
                  },
                  rich: {
                    a: {
                      width: 40,
                      height: 40,
                      lineHeight: 50,
                      shadowBlur: 0,
                      shadowColor: '#2b2a38',
                      shadowOffsetX: '1',
                      shadowOffsetY: '1',
                      backgroundColor: {
                        image: imgSrc,
                      },
                    },
                  },
                },
              },
            },
            {
              value: 100 - item.value,
              name: 'invisible',
              itemStyle: {
                normal: {
                  color: colors[index][0][1],
                },
                emphasis: {
                  color: colors[index][0][1],
                },
              },
            },
          ],
        });
      });
      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        // title: titleArr,
        series: seriesArr,
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        // this.axios({
        //   method: 'get',
        //   url: ChartsData.apiData.apiUrl,
        // })
        let param = {
          method: 'get',
          url: ChartsData.apiData.apiUrl,
        };

        request(param)
          .then(res => {
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '多项换行环形图',
    componentName: 'Pie6Charts',
    componentOverViewImg: './img/charts/PieCharts/Pie6Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['人数'],
            source: [
              {
                s: '人数',
                x: '导游',
                y: 16,
                i: 1,
              },
              {
                s: '人数',
                x: '票务员',
                y: 27,
                i: 2,
              },
              {
                s: '人数',
                x: '咨询员',
                y: 54,
                i: 3,
              },
              {
                s: '人数',
                x: '营销员',
                y: 92,
                i: 4,
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        // propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Pie6Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
